import { createFileRoute } from "@tanstack/react-router";

import { HalvingBoltConfigurator } from "~/features/gameSession/components/HalvingBoltConfigurator/HalvingBoltConfigurator.tsx";
import { parseHalvingBoltConfiguratorSearch } from "~/features/gameSession/components/HalvingBoltConfigurator/halvingBoltConfiguratorSearch.ts";

const HalvingBoltConfiguratorPage = () => {
    const navigate = Route.useNavigate();
    const search = Route.useSearch();

    return (
        <HalvingBoltConfigurator
            {...search}
            onChange={(change) => navigate({ search: { ...search, ...change }, replace: true })}
        />
    );
};

export const Route = createFileRoute("/_auth/dev/presenter-configurator")({
    validateSearch: parseHalvingBoltConfiguratorSearch,
    component: HalvingBoltConfiguratorPage,
});
